module.exports = __webpack_public_path__ + "static/media/site-settings.1480743c.jpeg";